<main class="fadeIn">
  <div class="container-fluid">
    <div class="row" *ngIf="page!=='preferred-detail-view' ">
      <div class="col-12">
        <div class="header d-flex justify-content-between">
          <div class="d-flex align-items-center pr-header-with-details">
            <a class="back tool-wrap position-relative" role="button" (click)="back()">
              <div class="custom-tooltip tooltip-top" role="tooltip">
                <div class="arrow"></div>
                <div class="tooltip-inner"> Back </div>
              </div>
            </a>
            <h1>{{page=='diagnosis-detail-view'?"Diagnosis Details":"Allergy Details"}}</h1>
            <div class="details" *ngIf="versionDetailsHeader?.version">
              <span class="with-border">
                Version : {{versionDetailsHeader.version}}
              </span>
              <span *ngIf="versionDetailsHeader?.activeFrom && versionDetailsHeader?.expiredOn ">
                Validity : {{ versionDetailsHeader.activeFrom | dateFormat}} -
                {{ versionDetailsHeader.expiredOn | dateFormat}}
              </span>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="filter-body">
          <div class="filter">
            <div class="row">
              <div class="col-10">
                <div class="row" [formGroup]="versionForm">
                  <div class="col-3">
                    <input type="text" class="form-control " id="DLCodeSearch" formControlName="code"
                      appPreventFirstSpace
                      [placeholder]="page=='diagnosis-detail-view'?'Search by Diagnosis Code':'Search by Allergy Code'">
                  </div>
                  <div class="col-3">
                    <input type="text" class="form-control " id="DLNameSearch" formControlName="filterByName"
                      appPreventFirstSpace
                      [placeholder]="page=='diagnosis-detail-view'?'Search by Diagnosis Name':'Search by Allergy Name'">
                  </div>
                  <div class="col-2 d-flex">
                    <button id="btnDrugFilterApplyDetails" type="button" class="btn btn-dark-blue"
                      (click)="filterOnClick()" [ngClass]="{'disabled':versionForm.invalid}">APPLY</button>
                    <a class="reset-btn" (click)="resetFilter()"><span></span>Reset</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="page=='diagnosis-detail-view'">
        <div class="benefit-map-table " *ngIf="!fetchingInProgress && diagnosisDetailsList?.length">
          <div class=" table-container">
            <table class="table table-borderless table-bg">
              <caption class="d-none">drug details table</caption>
              <thead>
                <tr>
                  <th scope="col">Diagnosis Code</th>
                  <!-- <th scope="col" style="width: 200px;">Diagnosis Name</th>
                  <th scope="col">Diagnosis Principal</th> -->
                  <th scope="col">Diagnosis Classification</th>
                  <th scope="col" style="width: 260px;">Diagnosis Description</th>
                </tr>
              </thead>
              <tbody *ngFor="let diagnosis of diagnosisDetailsList">
                <tr>
                  <td>{{diagnosis?.diaganosisCode || '-' | uppercase}}</td>
                  <!-- <td>{{diagnosis?.diaganosis || '-' }}</td>
                  <td>{{diagnosis?.diaganosisPricipal || '-' | uppercase}}</td> -->
                  <td>{{diagnosis?.diaganosisClassification || '-' | uppercase}}</td>
                  <td>{{diagnosis?.diaganosisDesc || '-' }}</td>
                </tr>
                <tr class="spacer"></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="page=='allergy-detail-view'">
        <div class="benefit-map-table " *ngIf="!fetchingInProgress && allergyDetailsList?.length">
          <div class=" table-container has-scroll">
            <table class="table table-borderless table-bg">
              <caption class="d-none">drug details table</caption>
              <thead>
                <tr>
                  <th scope="col">Allergy Code</th>
                  <th scope="col" style="width: 260px;">Allergy</th>
                  <th scope="col">Allergy Severity</th>
                  <th scope="col" style="width: 260px;">Allergy Description</th>
                  <th scope="col" style="width: 260px;">PBM Allergy Code</th>
                </tr>
              </thead>
              <tbody *ngFor="let allergy of allergyDetailsList">
                <tr>
                  <td>{{allergy?.allergyCode || '-' | uppercase}}</td>
                  <td>{{allergy?.allergy || '-' }}</td>
                  <td>{{allergy?.severity || '-' }}</td>
                  <td>{{allergy?.allergyVersionDesc || '-' }}</td>
                  <td>{{allergy?.medispanAllergyName || '-' }}</td>
                </tr>
                <tr class="spacer"></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data with-border" *ngIf="!fetchingInProgress && !(diagnosisDetailsList?.length || allergyDetailsList?.length)">
      <img src="./assets/images/icons/no-data-img.svg" alt="">
      <p>No Data Found</p>
    </div>
    <app-navigation [listLength]="totalCount" [pageNo]="page_no" (currentPageDetail)="currentPageDetail($event)">
    </app-navigation>

  </div>
</main>